type Translate = (
  key: string,
  options?: Record<string, unknown>
) => { toString(): string };

export const formatMaxFileSize = (bytes: number): string => {
  const gigabytes = bytes / 1024 ** 3;
  if (gigabytes >= 1) {
    return `${new Intl.NumberFormat("it-IT", {
      maximumFractionDigits: 1,
    }).format(gigabytes)} GB`;
  }

  const megabytes = bytes / 1024 ** 2;
  return `${new Intl.NumberFormat("it-IT", {
    maximumFractionDigits: megabytes >= 10 ? 0 : 1,
  }).format(megabytes)} MB`;
};

export const uploadErrorMessage = (
  errorCode: unknown,
  t: Translate,
  maxFileSize?: number
): string => {
  if (errorCode === "ERR_ATTACHMENT_TOO_LARGE") {
    if (maxFileSize && maxFileSize > 0) {
      return t(
        "messages.sharepointCompose.uploadErrorCodes.ERR_ATTACHMENT_TOO_LARGE_WITH_LIMIT",
        { maxSize: formatMaxFileSize(maxFileSize) }
      ).toString();
    }
    return t(
      "messages.sharepointCompose.uploadErrorCodes.ERR_ATTACHMENT_TOO_LARGE"
    ).toString();
  }

  if (
    errorCode === "ERR_ATTACHMENT_TYPE" ||
    errorCode === "InvalidFileError"
  ) {
    return t(
      "messages.sharepointCompose.uploadErrorCodes.ERR_ATTACHMENT_TYPE"
    ).toString();
  }

  return t("messages.sharepointCompose.uploadErrorCodes.Error").toString();
};

export const uploadErrorCode = (err: unknown): unknown =>
  (err as { response?: { data?: { error_code?: unknown } } })?.response?.data
    ?.error_code;

export const isFileTooLarge = (
  file: File,
  maxFileSize: number | undefined
): boolean =>
  typeof maxFileSize === "number" && maxFileSize > 0 && file.size > maxFileSize;
